import { render, staticRenderFns } from "./AlgoliaCSGHits.vue?vue&type=template&id=537a68b3&scoped=true&"
import script from "./AlgoliaCSGHits.vue?vue&type=script&lang=ts&"
export * from "./AlgoliaCSGHits.vue?vue&type=script&lang=ts&"
import style0 from "./AlgoliaCSGHits.vue?vue&type=style&index=0&id=537a68b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a68b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('537a68b3', component.options)
    } else {
      api.reload('537a68b3', component.options)
    }
    module.hot.accept("./AlgoliaCSGHits.vue?vue&type=template&id=537a68b3&scoped=true&", function () {
      api.rerender('537a68b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/search/AlgoliaCSGHits.vue"
export default component.exports